import React, {Component} from 'react';
import {connect} from 'react-redux';
import IconButton from 'material-ui/IconButton';
import AccountCircle from 'material-ui-icons/AccountCircle';
import AccountBalanceWallet from 'material-ui-icons/AccountBalanceWallet';
import Menu, {MenuItem} from 'material-ui/Menu';
import {logout} from "../login/LoginAction";
import {translate} from 'react-i18next';
import {
    navigationToFriends, navigationToPause, navigationToReorder, navigationToWallet,
    resetNavigationToLevel
} from "../navigation/NavigationActions";
import Dialog, {
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import Button from 'material-ui/Button';
import List from 'material-ui/List';
import InfoSnack from "../utils/InfoSnack";
import Reload from "../components/Reload";
import {daysFetchData} from "./OverviewAction";
import LanguageSwitcher from "./LanguageSwitcher";


class OverviewBar extends Component {

    constructor() {
        super();
        this.state = {
            anchorEl: null,
            open: false,
        };
    }

    handleChange = (event, checked) => {
        this.setState({auth: checked});
    };

    handleMenu = event => {
        this.setState({anchorEl: event.currentTarget});
    };

    handleClose = () => {
        this.setState({anchorEl: null});
    };

    askBeforePayout = () => {
        this.setState({open: true});
    };

    handleCloseDialog = () => {
        this.setState({open: false});
    };

    render() {
        const {anchorEl} = this.state;
        const open = Boolean(anchorEl);
        return (

            <div className="overviewHeader">
                <InfoSnack onRef={ref => (this.infoSnack = ref)}/>
                <h1 style={styles.flex}>{this.props.t('overview:title')}</h1>

                <div>

                    <Reload
                        onReload={() => this.props.fetchDays()}
                        loading={this.props.extendLoading || this.props.payoutLoading || this.props.daysLoading}/>
                    {(!this.props.retry && this.props.betMode) === 2 && (
                    <IconButton
                        aria-owns={open ? 'menu-appbar' : null}
                        aria-haspopup="true"
                        onClick={() => this.props.navigationToWallet()}
                        color="inherit">
                        <AccountBalanceWallet />
                    </IconButton>)}
                    <IconButton
                        aria-owns={open ? 'menu-appbar' : null}
                        aria-haspopup="true"
                        onClick={this.handleMenu}
                        color="inherit">
                        <AccountCircle />
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={open}
                        onClose={this.handleClose}>

                        {/*<MenuItem onClick={() => {
                            this.handleClose();
                            this.props.navToFriends();
                        }}>{this.props.t('common:shareTo')}</MenuItem>*/}

                        <MenuItem onClick={() => {
                            this.handleClose();
                        }}> <LanguageSwitcher t={this.props.t}/></MenuItem>

                        <MenuItem disabled={this.props.retry} onClick={() => {
                            this.handleClose();
                            this.props.navToLevel();
                        }}>{this.props.t('common:changeLevel')}</MenuItem>


                        <MenuItem disabled={this.props.openDays <= 2 || this.props.retry} onClick={() => {
                            this.handleClose();
                            this.props.navigationToReorder();
                        }}>{this.props.t('common:moveDays')}</MenuItem>)

                        <MenuItem disabled={this.props.retry} onClick={() => {
                            this.handleClose();
                            this.props.navigationToPause();
                        }}>{this.props.t('common:pause')}</MenuItem>

                        <MenuItem onClick={() => {
                            this.handleClose();
                            this.props.logout();
                        }}>{this.props.t('common:logout')}</MenuItem>
                    </Menu>
                </div>

                <Dialog
                    open={this.state.open}
                    onClose={this.handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{this.props.t('common:appName')}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.props.t('common:askPayout')}
                        </DialogContentText>
                    </DialogContent>

                    <List>
                        <Button fullWidth={true} size="large" onClick={() => {
                            this.handleCloseDialog();
                            this.props.fetchPayout()
                        }} color="primary">
                            {this.props.t('common:doPayout')}
                        </Button>
                        <Button fullWidth={true} size="large" onClick={() => {
                            this.handleCloseDialog();
                            this.props.fetchExtend()
                        }}
                                color="primary" autoFocus>
                            {this.props.t('common:dontPayout')}
                        </Button>
                    </List>

                </Dialog>
            </div>

        );
    }
}

const styles = {
    flex: {
        flex: 1,
    },
};

const mapStateToProps = (state) => {
    return {
        daysLoading: state.daysLoading,
        openDays: state.openDays,
        betMode: state.betMode,
        retry: state.retry,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => dispatch(logout()),
        navToLevel: () => dispatch(resetNavigationToLevel()),
        navigationToPause: () => dispatch(navigationToPause()),
        navigationToWallet: () => dispatch(navigationToWallet()),
        navigationToReorder: () => dispatch(navigationToReorder()),
        //navToConnect: () => dispatch(navigationToConnect()),
        fetchDays: () => dispatch(daysFetchData())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate(['overview', 'common'])(OverviewBar));





// WEBPACK FOOTER //
// ./src/overview/OverviewBar.js